'use strict';

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var Cache =
/*#__PURE__*/
function (_Map) {
  _inherits(Cache, _Map);

  function Cache(timeout) {
    var _this;

    _classCallCheck(this, Cache);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cache).call(this));
    _this.timeout = timeout;
    return _this;
  }

  _createClass(Cache, [{
    key: "add",
    value: function add(peerId, descriptor) {
      var _this2 = this;

      this.set(peerId, descriptor);
      setTimeout(function () {
        _this2.has(peerId) && _this2.delete(peerId);
      }, this.timeout);
    }
  }]);

  return Cache;
}(_wrapNativeSuper(Map));

module.exports = Cache;